(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CommissionCustom', CommissionCustom);

    CommissionCustom.$inject = ['$resource', 'DateUtils'];

    function CommissionCustom($resource, DateUtils) {


        var getAllCompanyCommission = function () {

            var resourceUrl = 'api/get-all-company-commissions';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getLastServantCommission = function (id) {
            var resourceUrl = 'api/get-last-servant-commission' + '/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var calculateCommission = function () {
            var resourceUrl = 'api/calculate-commission';
            //?servantId=' + servantId+ '&fromDate=' + DateUtils.convertToISOString(fromdate) + '&toDate=' + DateUtils.convertToISOString(todate)
            return $resource(resourceUrl, {}, {}
            );
        }

        return {
            getAllCompanyCommission: getAllCompanyCommission,
            getLastServantCommission: getLastServantCommission,
            calculateCommission: calculateCommission

        };
    }
})();
